import { Seo } from "@/components/Seo";
import { Exhibitions } from "@/components/Exhibitions";
import { useLang } from "@/i18n";

export default function NewsPage() {
  const { t } = useLang();
  return (
    <>
      <Seo title={t.seo.news.title} description={t.seo.news.description} path="/news" />
      <Exhibitions h1 />
    </>
  );
}
